<template>
  <div
    class="recently-viewed-products critical-component-clear"
    :class="[{ [$class('hidden')]: products.length < 1 }, `${gridModifier}`]"
  >
    <div class="recently-viewed-products__header">
      <h2
        class="
          recently-viewed-products__header-title
          text-desktop-regular-uc-desktop
          text-mobile-regular-uc-mobile
        "
        v-text="$string('product.recently_viewed.title')"
      />
    </div>

    <div
      class="recently-viewed-products__grid grid"
      :class="`recently-viewed-products__grid--limit-${section.productLimit}`"
      data-gtm-event="recently-viewed-products"
    >
      <template
        v-for="(product, index) of products"
        :key="`recently-viewed-${index}`"
      >
        <product-card
          v-if="product.id !== section.currentProductId"
          :product="product"
          :enable-quick-add="section.enableQuickAdd"
          :show-badge="section.showBadges"
          :show-flat-image="section.showFlatImages"
          class-name="product-card--medium
          recently-viewed-products__column
          col
          xs2
          l3"
        />
      </template>
    </div>

    <secondary-product-data
      context="recently-viewed"
      :limit="section.productLimit"
      @products-updated="handleProductsUpdate"
    />
  </div>
</template>

<script>

/**
 * Vue: Recently viewed products (recently-viewed-products)
 * -----------------------------------------------------------------------------
 * Section displaying recently viewed products.
 *
 * @param {Object} section - Section settings.
 *
 */
import { mapState } from 'vuex'

import ProductCard from '~async/product-card/product-card'
import SecondaryProductData from '~async/main-product/secondary-product-data'

export default {
  name: 'RecentlyViewedProducts',

  components: {
    ProductCard,
    SecondaryProductData,
  },

  props: {
    section: {
      type: Object,
      default: () => ({
        enableQuickAdd: false,
        productLimit: 4,
        showBadges: false,
        showFlatImages: true,
        currentProductId: false,
      }),
    },
  },

  data() {
    return {
      products: [],
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
    gridModifier() {
      return `grid-cols-${this.products.length}`
    },
  },

  methods: {

    /**
     * Returns a value depending on the screen size.
     * The value indicates the position relative to the top of the viewport.
     * @returns {String}
     */
    checkSize() {
      return this.isMobile ? '120' : '160'
    },

    /**
     * Handles products being updated by the secondary product data component.
     * @param {Array} products - Array of product objects.
     */
    handleProductsUpdate(products) {
      if (products.length === 0) {
        this.products = []
        return
      }

      this.products = [...products]
    },
  },
}
</script>

<style lang="scss">
@import './recently-viewed-products';
</style>
